import React from "react";
import PropTypes from "prop-types";

const PoonaWallaBasicLoader = ({ clx, clxInner, clxTitle, isLoading }) => {
  return (
    isLoading && (
      <>
        {/* LOADER STARTS */}
        <div className={`w-100 text-center ${clx}`}>
          <span
            className={`spinner-border ${clxInner || "text-secondary-poonawalla"} m-5`}
            role="status"
          >
            <span className={`sr-only ${clxTitle}`}>Loading...</span>
          </span>
        </div>
        {/* LOADER ENDS */}
      </>
    )
  );
};

export default PoonaWallaBasicLoader;

PoonaWallaBasicLoader.propTypes = {
  clx: PropTypes.string,
  clxInner: PropTypes.string,
  clxTitle: PropTypes.string,
  isLoading: PropTypes.bool,
};
